import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    loadMore: boolean;
};

export const DispatchSetLoadMore: CustomApiHandler<Parameter, boolean> = props => {
    props.dispatch({
        type: "Custom/ProductList/SetLoadMore",
        result: props.parameter.loadMore,
    });
};

export const chain = [DispatchSetLoadMore];

const loadMorePLP = createHandlerChainRunner(chain, "loadMorePLP");
export default loadMorePLP;
